import initializeAppMenu from "./menu.js";

if (
  typeof window !== "undefined" &&
  typeof document !== "undefined" &&
  typeof customElements !== "undefined"
) {
  initializeAppMenu();
}

export default initializeAppMenu;
